import { ring } from "ldrs";
ring.register();

const Loader = ({ loadingTitle, showLogo = false }) => {
  return (
    <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: "14px", margin: "60px 0", flexDirection: 'column' }}>
      {showLogo ? <img src="/logo.svg" alt="logo" style={{width: '200px', marginBottom: '40px'}}/> : <></>}
      <l-ring size="40" stroke="5" bg-opacity="0" speed="1.4" color="#3273FA"></l-ring>
      <h2 style={{ margin: "0", fontSize: "18px", color: "white" }}>{loadingTitle}</h2>
    </div>
  );
};

export default Loader;
